import {ComponentData} from "../../engine/tools/EntityManager";
import {SoundInstance} from "../../engine/tools/AudioLoader";

export class TensionSound implements ComponentData {

    instancePump: SoundInstance
    instanceRelease: SoundInstance

    constructor(options?: Partial<TensionSound>) {
        Object.assign(this, options)
    }
}